import { useEffect } from "react";

/**
 * Attaches a mousedown listener to the shadow root to detect
 * clicks outside the phone input dropdown.
 */
export const useClickOutsideListener = (shadowRoot: ShadowRoot, onClickOutside: (event: Event) => void) => {
  useEffect(() => {
    shadowRoot.addEventListener("mousedown", onClickOutside);
    return () => shadowRoot.removeEventListener("mousedown", onClickOutside);
  }, [shadowRoot, onClickOutside]);
};
